<template>
  <div class="ProtocoloForm">
    <b-modal visible
             size="xl"
             centered
             no-close-on-backdrop
             no-close-on-esc
             no-close
             hide-header-close
             header-bg-variant="secondary"
             header-text-variant="light"
             hide-footer>
      <template slot="modal-header">
        <div class="row ">
          <div class="col">
            <h5 class="ProtocoloForm--header">
              Novo protocolo {{ proximoNumeroProtocolo ? ` - ${proximoNumeroProtocolo}` : '' }}
            </h5>
          </div>
        </div>
      </template>
      <div v-if="edit"
           class="row">
        <div class="col-4">
          <label class="label"
                 for="data_procolor">Número <span class="text-danger">*</span></label>
          <input v-model="protocolo.numero"
                 :disabled="!!protocolo.id"
                 type="number"
                 class="form-control form-control-sm">
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col-2 col-sm-3">
          <CustomInput
            name="data_protocolo"
            label="Data protocolo"
            type="date"
            :initial-value="protocolo.data_protocolo"
            :required="true"
            :form-erros="formErros"
            @setError="setError"
            @blur="setValueInput" />
        </div>
        <div class="ml-3">
          <CustomRadioInput name="tipo_registro"
                            :options="registroOptions"
                            :checked-option="protocolo.tipo_registro"
                            label="Tipo Registro"
                            :form-erros="formErros"
                            :required="true"
                            @setInputRadio="(value) => protocolo.tipo_registro = value" />
        </div>
      </div>
      
      <div class="d-flex pb-2">
        <CustomInput
          class="col-4"
          name="matricula"
          label="Número da matrícula"
          type="text"
          :initial-value="protocolo.matricula"
          mask-type="matricula"
          validate-type="matricula"   
          @blur="setValueInput" />
        <div class="col-5">
          <CustomSelect
            name="natureza"
            label="Natureza"
            :required="true"
            :form-erros="formErros"
            :options="computedOptionsNatureza" 
            :selected="protocolo.natureza"
            @setSelectValue="selectOption" />
        </div>
      </div>
      
      <div v-for="(parte, index) in protocolo.partes"
           :key="`parte_${ index }_${ _uid }`">
        <div v-if="parte"
             class="d-flex mt-2 pb-2">
          <CustomInput
            class="col-2"
            name="cpf"
            label="CPF/CNPJ"
            validate-type="cpfOrCnpj"
            type="text"
            :required="true"
            :form-erros="formErros"
            :initial-value="parte.cpf"
            placeholder=""
            error-mensage="CPF é um campo obrigatório"
            mask-type="cpf"
            @setError="setError"
            @blur="(data, value) => parte.cpf = value" />
        
          <CustomInput
            class="col-8 ml-4 mr-4"
            name="nome"
            label="Nome requerente"
            :form-erros="formErros"
            :initial-value="parte.nome"
            :required="true"
            type="text"
            @blur="(data, value) => parte.nome = value" />
          <div v-if="index > 0"
               class=" d-flex justify-content-end align-items-end ml-4 ">
            <CustomButton text="Limpar"
                          variant="outline-danger"    
                          @click="() => removePartes(index)" />
          </div>
        </div>
      </div>

      <div class="mt-3 mb-3">
        <button id="addItens"
                class="col-12 btn btn-outline-primary"
                @click="addPartes">
          <IconSvg class="icon-add"
                   icon="add" />
          Adicionar mais itens 
        </button>
      </div>

      <div class="row mt-4 mb-4">
        <div class="col-2 col-sm-2">
          <label class="label">Status</label>
          <b-form-radio-group     
            v-model="protocolo.status"
            :disabled="edit"
            :options="[{ text: 'Em andamento', value: 'EM_ANDAMENTO' }, { text: 'Cumprido', value: 'CUMPRIDO' }]" />
        </div>
        <div v-if="protocolo.status == 'CUMPRIDO'"
             class="col-sm-3">
          <label class="label"
                 for="data_cumprimento">Data de cumprimento<span class="text-danger">*</span></label>
          <input id="data_cumprimento"
                 v-model="protocolo.data_cumprimento"
                 v-validate="`required|date_format:yyyy-MM-dd|date_between:${ protocolo.data_protocolo },${ getDataAtual() },(include)`"
                 type="date"
                 name="data_cumprimento"
                 :class="{ 'is-invalid text-danger': errors.has('data_cumprimento') }"
                 class="form-control form-control-sm">
          <small v-if="errors.has('data_cumprimento')"
                 class="text-danger">
            {{ errors.first('data_cumprimento') }}
          </small>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <label class="label"
                 for="observacao_protocolo">
            Informações adicionais
          </label>
          <textarea id="observacao_protocolo"
                    v-model="protocolo.observacao"
                    v-validate="'max: 500'"
                    name="observacao_protocolo"
                    class="form-control form-control-sm"
                    :class="{ 'is-invalid text-danger': errors.has('observacao_protocolo') }"
                    cols="30"
                    rows="5" />
          <small class="text-danger text-bold">
            {{ errors.first('observacao_protocolo') }}
          </small>
        </div>
      </div>
      <hr class="hr-secondary">
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-sm btn-outline-secondary"
                  @click="$emit('onCloseModal')">
            Voltar
          </button>
          <button class="btn btn-sm btn-secondary ml-2"
                  @click="save()">
            {{ edit ? 'Editar' : 'Adicionar' }}
          </button>
        </div>
      </div> 
    </b-modal>
  </div>
</template>

<script>
  /* libraries */
  import moment from "moment"
  import CustomButton from '@/components/CustomButton/CustomButton'
  import CustomRadioInput from '@/components/CustomRadioInput/CustomRadioInput'

  // Cinstants
  import { TiposRegistro } from "@/constants/registro"

  // Componets
  import CustomSelect from "../../CustomInputs/CustomSelect"
  import CustomInput from '../../CustomInputs/CustomInput'
  import ProtocoloConfigService from "../../../services/Protocolos/ProtocoloConfigService"

  // Utils
  import { formatarCamposErrorMessage } from "../../../utils/conversors"

  export default {
    name: "ProtocoloForm",
    components: {
      CustomButton,
      CustomRadioInput,
      CustomButton,
      CustomInput,
      CustomSelect
    },
    props: {
      propProtocolo: {
        type: Object,
        default: () => ({})
      },
      propNaturezas: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        edit: false,
        proximoNumeroProtocolo: null,
        protocolo: {
          data_protocolo: moment(new Date()).format('YYYY-MM-DD'),
          data_cumprimento: null,
          natureza: null,
          tipo_registro: null,
          partes: [
            {
              cpf: null,
              nome: null
            }
          ],         
          matricula: null,
          status: 'EM_ANDAMENTO',
          observacao: null,          
        },
        formErros: [],
        registroOptions: TiposRegistro || []
      }
    },
    computed: {
      computedOptionsNatureza () {
        const options =  this.propNaturezas.map((item) =>  ({ text: item, value: item, name: 'natureza'} ))
        return options
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        if (Object.values(this.propProtocolo).length > 0) {
          this.protocolo = { ...this.propProtocolo }

          if (this.protocolo.informacoes) {
            const matricula = this.protocolo.informacoes.find(info => info.chave == 'matricula')
            if (matricula) this.protocolo.matricula = matricula.valor
          }

          this.edit = true
        }
        this.proximoNumeroProtocolo = await new ProtocoloConfigService.getLastNumber() || null
        if (this.proximoNumeroProtocolo) {
          this.proximoNumeroProtocolo = `${this.proximoNumeroProtocolo}/${moment().format('YYYY')}`
        }

      },
      setValueInput (nome, value) {
        this.protocolo[nome] = value
      },
      setError (newArray) {
        this.formErros = newArray
      },
      selectOption (option) {
        if (!option) return this.protocolo.natureza = null
        this.protocolo.natureza = option.value
      },
      async save () {
        if (this.formErros.length) {
          const errorMessage = `Preencha todos os campos obrigatórios antes de continuar: ${formatarCamposErrorMessage(this.formErros)}`
          return displayMessage('error', 'Erro!', errorMessage)
        }

        if (this.protocolo.matricula) this.protocolo.matricula = this.protocolo.matricula.replace(/_/g, '')

        if (this.protocolo.status != 'CUMPRIDO') {
          this.protocolo.data_cumprimento = null
        }

        this.$emit('onSaveProtocolo', this.protocolo)
        
      },
      getDataAtual () {
        return moment().format('YYYY-MM-DD')
      },
      async changeNatureza (natureza) {
        if (natureza) {
          this.protocolo.natureza = natureza
        }
      },
      addPartes () {
        this.protocolo.partes.push({nome: null, cpf: null})
      },
      removePartes (index) {
        this.protocolo.partes.splice(index, 1)
      }
    }
  }
</script>

<style lang="scss">
  @import 'src/scss/_utilities/_exports.scss';
  .ProtocoloForm {
    &--header {
      /*color: white;*/
    }
  }
  .icon-add {
    fill: #1c7af5;
    width: 20px;
    height: 20px;
    transition: fill 0.2s;
  }
</style>
